import { render, staticRenderFns } from "./statisticFilterOfFields.vue?vue&type=template&id=504533e5&scoped=true"
import script from "./statisticFilterOfFields.vue?vue&type=script&lang=js"
export * from "./statisticFilterOfFields.vue?vue&type=script&lang=js"
import style0 from "./statisticFilterOfFields.vue?vue&type=style&index=0&id=504533e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504533e5",
  null
  
)

export default component.exports